import {useQuery} from '@tanstack/react-query'

import {STALE} from '#/state/queries'
import {useSession} from '#/state/session'

const INVITE_WORKER_URL = 'https://batesky-invite-system.attps.workers.dev'

const RQKEY_ROOT = 'batesky-invites'
export const RQKEY = [RQKEY_ROOT]

export interface BateskyInvite {
  code: string
  isUsed: boolean
  usedByUsername: string | null
  usedAt: string | null
  createdAt: string
}

export function useBateskyInvitesQuery() {
  const {currentAccount} = useSession()

  return useQuery<BateskyInvite[]>({
    staleTime: STALE.MINUTES.FIVE,
    queryKey: RQKEY,
    async queryFn() {
      const res = await fetch(`${INVITE_WORKER_URL}/my-invites`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({userDid: currentAccount?.did}),
      })

      if (!res.ok) {
        throw new Error('Failed to fetch invite codes')
      }

      const data = (await res.json()) as {invites: BateskyInvite[]}
      return data.invites
    },
    enabled: !!currentAccount?.did,
  })
}
